var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-upload"},[_c('input',{attrs:{"type":"file"},on:{"change":_vm.read}}),_c('div',{staticClass:"image-preview"},[_c('img',{attrs:{"src":_vm.preview}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }